import axios from 'axios';
import storage from './storage';
import differenceInDays from 'date-fns/differenceInDays';
import fromUnixTime from 'date-fns/fromUnixTime';

const utils = {
	async getYouTubeVideoDetails(videoId) {
		var YouTubes = [
			'AIzaSyDTG1lyCcQfF9ZDy_u7kusUSvj-KGiT4K8',
			'AIzaSyA0UyYN8NClcNgXr3vx4w4nCFcHFvilgsM',
			'AIzaSyDOVwAK8o_Rdy6_Rpk18q5d8NpPZrgSFus',
			'AIzaSyA5KFdkNeTddW2dAH_5Ik97-q_1aZlz3kI',
			'AIzaSyABzmHUFOCn0dC7GQDOYZ8q9CAe-xPJjDY',
			'AIzaSyBKjGCr19m-_PYEv8_Q0gX47HnCLPMx-qE',
			'AIzaSyDwWwmLpN8QW8cSOIJcH_aUZEoGGkUkU3E',
			'AIzaSyCDzJ6H1ScrY6QA9kXD3mIYHYWZlrFh0tE',
			'AIzaSyD3z7_kweSf0-_lDeTGCzU1asUNe-_PG8o',
			// "AIzaSyDMR9jhIcKwQbLpFi2wBa5cqGV1XUmui5M"
		];
		var myYouTube = YouTubes[Math.floor(Math.random() * YouTubes.length)];
		try {
			const videoUrl = `https://www.googleapis.com/youtube/v3/videos?part=snippet,statistics&id=${videoId}&key=${myYouTube}`;

			const response = await fetch(videoUrl);
			const data = await response.json();

			if (data.items && data.items.length > 0) {
				const videoItem = data.items[0];

				return {
					views: videoItem.statistics.viewCount,
					author: videoItem.snippet.channelTitle,
					channelId: videoItem.snippet.channelId,
					profilePicture: videoItem.snippet.thumbnails.default
						? videoItem.snippet.thumbnails.default.url
						: null,
					title: videoItem.snippet.title,
					description: videoItem.snippet.description,
					publishedAt: videoItem.snippet.publishedAt,
				};
			} else {
				throw new Error('Unable to fetch details for the video.');
			}
		} catch (err) {
			const videoUrl = `https://www.googleapis.com/youtube/v3/videos?part=snippet,statistics&id=${videoId}&key=${myYouTube}`;

			const response = await fetch(videoUrl);
			const data = await response.json();
			console.log(data);

			if (data.error.code == 403) {
				console.log('234923' + myYouTube);
				console.log('API Quota Exceeded');
				btn.innerText = 'Error saving API Quota Exceeded';
				btn.style.backgroundColor = '#F00';
				throw new Error('API Quota Exceeded');

				return;
			}

			if (data.items && data.items.length > 0) {
				const videoItem = data.items[0];

				return {
					views: videoItem.statistics.viewCount,
					author: videoItem.snippet.channelTitle,
					channelId: videoItem.snippet.channelId,
					profilePicture: videoItem.snippet.thumbnails.default
						? videoItem.snippet.thumbnails.default.url
						: null,
					title: videoItem.snippet.title,
					description: videoItem.snippet.description,
					publishedAt: videoItem.snippet.publishedAt,
				};
			} else {
				throw new Error('Unable to fetch details for the video.');
			}
		}
	},
	async extractYouTubeVideoId(url) {
		const regex = /(\/vi\/|\/embed\/)([A-Za-z0-9_-]+)/;
		const match = url.match(regex);
		if (match && match[2]) {
			return 'https://www.youtube.com/watch?v=' + match[2];
		} else {
			return null;
		}
	},
	async extractYouTubeId(url) {
		const regex = /(\/vi\/|\/embed\/)([A-Za-z0-9_-]+)/;
		const match = url.match(regex);
		if (match && match[2]) {
			return match[2];
		} else {
			return null;
		}
	},
	async fetchBlockId(baseUrl, metaId) {
		let token = await storage.getStorage();

		let config = {
			headers: {
				Authorization: `Bearer ${token}`,
			},
		};

		let url = `${baseUrl}block/id`;

		let response = null;

		let payload = {
			metaId,
		};

		response = await axios.post(url, payload, config).catch((err) => {
			return err.response || null;
		});

		return response.data || null;
	},
	async fetchVideo(url) {
		let payload = null;
		let opts = {
			// headers: {
			//   "sec-fetch-dest": "video",
			//   "sec-fetch-mode": "no-cors",
			//   "sec-fetch-site": "cross-site",
			// },
		};
		try {
			payload = await fetch(url, opts);
		} catch (err) {
			// Sleep for a sec
			await new Promise((r) => setTimeout(r, 5000));
			payload = await fetch(url, opts).catch((err) => {});
		}

		if (!payload) {
			return null;
		}

		let data = await payload.arrayBuffer(32);

		return data;
	},
	async loadVideo(url) {
		let data = await this.fetchVideo(url);

		if (!data) {
			return null;
		}

		let blob = new Blob([data], { type: 'video/mp4' });

		//let base64 = this.arrayBufferToBase64(buff, "mp4", "test.mp4");

		return blob;
	},
	async saveAd(baseUrl, payload) {
		let token = await storage.getStorage();

		let config = {
			headers: {
				Authorization: `Bearer ${token}`,
			},
		};

		let url = `${baseUrl}block`;

		let response = null;

		response = await axios.post(url, payload, config).catch((err) => {
			return err.response || null;
		});

		return response;
	},
	videoDimensions: function (video) {
		// Ratio of the video's intrisic dimensions
		var videoRatio = video.videoWidth / video.videoHeight;
		// The width and height of the video element
		var width = video.offsetWidth,
			height = video.offsetHeight;
		// The ratio of the element's width to its height
		var elementRatio = width / height;
		// If the video element is short and wide
		if (elementRatio > videoRatio) width = height * videoRatio;
		// It must be tall and thin, or exactly equal to the original ratio
		else height = width / videoRatio;
		return {
			width: width,
			height: height,
		};
	},
	async getRatio(buttonEl) {
		let video = buttonEl.parentNode.parentNode.lastChild.querySelector('video');
		if (!video) {
			return;
		}
		let { width, height } = this.videoDimensions(video);
		// let style = getComputedStyle(video);
		// let width = style.width.replace("px", "");
		// let height = style.height.replace("px", "");
		let ratio = 1;
		width = parseInt(width);
		height = parseInt(height);
		ratio = height / width;

		return ratio;
	},
	async getImage(buttonEl) {
		let aAll = buttonEl.parentNode.parentNode.lastChild.querySelectorAll('a');
		if (!aAll) {
			return;
		}

		let image = null;

		aAll.forEach((el) => {
			if (el.firstChild && el.firstChild.querySelector) {
				let i = null;
				i = el.firstChild.querySelector('img');

				if (i) {
					image = i;
				}
			}
		});
		if (!image) {
			return;
		}

		return image.src;
	},
	async getStandaloneImage(buttonEl) {
		let image = buttonEl.parentNode.parentNode.lastChild.querySelector(
			':scope > div > div > div:nth-child(2) > div:nth-child(2) > img'
		);

		if (image) {
			return image.src;
		}
	},
	async getVideo(buttonEl) {
		let video = buttonEl.parentNode.parentNode.lastChild.querySelector('video');

		if (!video) {
			return;
		}

		return video.src;
	},
	async getIsEuAd(buttonEl) {
		let spanContainer = buttonEl.parentElement.querySelector(
			':scope > div:first-child > div:first-child > div:first-child'
		);
		if (!spanContainer) {
			return;
		}

		let spans = spanContainer.querySelectorAll('span');

		let validTexts = ['EU transparency', 'Transparence UE', 'EU-Transparenz'];

		let valid = false;

		for (let i = 0; i < spans.length; i++) {
			let span = spans[i];

			let text = span.innerText;

			if (validTexts.includes(text)) {
				valid = true;
				break;
			}
		}

		return valid;
	},
	async getCarousel(buttonEl) {
		if (
			buttonEl.parentNode.parentNode.lastChild.lastChild &&
			buttonEl.parentNode.parentNode.lastChild.lastChild.lastChild
		) {
			let aAll =
				buttonEl.parentNode.parentNode.lastChild.lastChild.lastChild.querySelector(
					' div:nth-child(3)'
				);
			if (!aAll) {
				return;
			}

			if (!aAll.firstChild) {
				return null;
			}

			if (typeof aAll.firstChild.querySelectorAll === 'undefined') {
				return null;
			}

			let images = aAll.firstChild.querySelectorAll('img');

			if (!images) {
				return null;
			}

			let carousel = [];

			for (let i = 0; i < images.length; i++) {
				carousel.push({
					type: 'carouselImage',
					assetPath: images[i].src,
				});
			}

			return carousel;
		} else {
			return null;
		}
	},
	redirectToDashboard: function (tempBlock) {
		let baseUrl = `https://app.swipekit.app`;

		if (process.env.VUE_APP_ENV === 'development') {
			baseUrl = `http://localhost:8080`;
		}

		let url = `${baseUrl}?blockid=${tempBlock.id}`;
		window.open(url, '_blank');
	},
	async checkForId(target, baseUrl) {
		let data = target.dataset.value;

		if (!data) {
			return;
		}

		try {
			data = JSON.parse(data);
		} catch (err) {}

		if (!data) {
			return;
		}

		let metaId = data.metaId;

		if (!metaId) {
			metaId = data.adArchiveID;
		}

		let blockId = null;

		if (!metaId) {
			return;
		}

		blockId = await this.fetchBlockId(baseUrl, metaId);

		if (!blockId) {
			return;
		}

		return blockId;
	},
	computeTempAd: function (data) {
		let categories = [];

		try {
			if (data.snapshot.pageCategories) {
				for (let key in data.snapshot.pageCategories) {
					categories.push(data.snapshot.pageCategories[key]);
				}
			}
		} catch (err) {
			console.log(err);
		}

		let meta = {
			eu_total_reach: data.eu_total_reach || 0,
			eu_ad_spend: data.eu_ad_spend || 0,
			type: data.snapshot.displayFormat,
		};

		let status = 'INACTIVE';

		if (data.isActive) {
			status = 'ACTIVE';
		}

		if (data.snapshot.displayFormat === 'dco') {
			meta.type = 'dco';
		}
		if (data.snapshot.displayFormat === 'dpa') {
			meta.type = 'dpa';
		}
		if (data.snapshot.displayFormat === 'multi_images') {
			meta.type = 'multi_images';
		}

		let assetType = data.snapshot.displayFormat;

		let startDate = fromUnixTime(data.startDate);
		let endDate = fromUnixTime(data.endDate);

		let activeDays = differenceInDays(startDate, endDate);

		activeDays = Math.abs(activeDays);

		if (!activeDays) {
			activeDays = 0;
		}

		let block = {
			status,
			isEu: data.isEu,
			assetType,
			eu_total_reach: data.eu_total_reach || 0,
			eu_ad_spend: data.eu_ad_spend || 0,
			metaId: data.adArchiveID,
			type: 'facebook',
			activeDays,
			meta,
			categories,
		};
		let ad = {
			block,
		};
		return ad;
	},
};

export default utils;
